export default "__VITE_ASSET__MtrE7P1X__"